import type { FieldType, ISiteHeadcount } from '@/interfaces'

export class SiteHeadcount implements ISiteHeadcount {
	[key: string]: FieldType
	id: number
	portlandHeadcount: number
	morganHillHeadcount: number
	losAngelesHeadcount: number
	chicagoHeadcount: number
	northCarolinaHeadcount: number
	hartfordHeadcount: number
	trumbullHeadcount: number
	constructor({
		id,
		portlandHeadcount,
		morganHillHeadcount,
		losAngelesHeadcount,
		chicagoHeadcount,
		northCarolinaHeadcount,
		hartfordHeadcount,
		trumbullHeadcount
	}: ISiteHeadcount) {
		this.id = id
		this.portlandHeadcount = portlandHeadcount
		this.morganHillHeadcount = morganHillHeadcount
		this.losAngelesHeadcount = losAngelesHeadcount
		this.chicagoHeadcount = chicagoHeadcount
		this.northCarolinaHeadcount = northCarolinaHeadcount
		this.hartfordHeadcount = hartfordHeadcount
		this.trumbullHeadcount = trumbullHeadcount
	}
}
